import Loader from 'core/components/Loader';


export default function PageLoader() {
  return (
    <Loader
      spinnerMargin='32px'
      spinnerWidth={64}
      spinnerHeight={64}
    />
  );
}
